module.exports = __webpack_public_path__ + "img/Ser cliente 768px.5d73421f.png";